import { Routes, Route } from 'react-router-dom';

import { HomeView } from '@VDL/views/HomeView/HomeView';
import { Level0View } from '@VDL/views/Level0View/Level0View';

export const AppRouter = () => {
  return (
    <Routes>
      <Route index element={<HomeView />} />
      <Route path=":level0Code" element={<Level0View />} />
    </Routes>
  );
};
